module.exports = __webpack_public_path__ + "img/slide-contact.c9317558.png";